// Generated with util/create-component.js
import React from "react";
import { StyleSheetManager } from "styled-components";
import isPropValid from "@emotion/is-prop-valid";
import { StyledNavigation } from "./Navigation.styled";
import Logo from "../../Assets/Logo/Logo";
import HamburgerIcon from "./HamburgerIcon";

type NavigationProps = {
  navLinksOpen: boolean;
  sportsLinksOpen: boolean;
  navHandler: () => void;
  sportsHandler: () => void;
}

/**
 * Navigation Component
 * 
 * This component renders a navigation bar.
 * 
 * @component
 * 
 * @param {Object} NavigationProps - The props for the Navigation component.
 * 
 * @returns {JSX.Element} Rendered Navigation component.
 */

const Navigation: React.FC<NavigationProps> = ({
  navLinksOpen, sportsLinksOpen, navHandler, sportsHandler
}: NavigationProps) => {

  return (
    <StyleSheetManager shouldForwardProp={isPropValid}>
      <StyledNavigation>
        <div className="navigation">
          <div className="nav-bar" id="nav-id">
            <div className="nav-assets">
              <a
                href="https://gamesheetinc.com/"
                className="nav-assets__logo"
              >
                <Logo logo="horizontal" size="100%" contrast="darkbg"/>
              </a>              
              <button
                className="nav-assets__hamburger"
                onClick={() => navHandler()}
              >
                <HamburgerIcon color="white"/>
              </button>
            </div>
            <ul className={`nav-links ${navLinksOpen ? "" : "nav-links--hidden"} ${sportsLinksOpen ? "nav-links--transition-delay" : ""}`}>
              <li className="nav-links__link">
                <a href="https://gamesheetinc.com/how-it-works">
                  How it Works
                </a>
              </li>
              <li className="nav-links__link">
                <button
                  className="nav-links__dropdown"
                  onClick={() => sportsHandler()}
                >
                  Sports
                </button>
              </li>
              <li className="nav-links__link">
                <a href="https://gamesheetinc.com/tournaments">
                  Tournaments
                </a>
              </li>
              <li className="nav-links__link">
                <a href="https://gamesheetinc.com/news">
                  News
                </a>
              </li>
              <li className="nav-links__link">
                <a href="https://gamesheetinc.com/testimonials">
                  Testimonials
                </a>
              </li>
              <li className="nav-links__link">
                <a href="https://gamesheetinc.com/faq">
                  FAQ
                </a>
              </li>
              <li className="nav-links__link nav-links__link--highlight">
                <a href="https://gamesheetinc.com/contact">
                  Contact
                </a>
              </li>
              <li className="nav-links__link">
                <a href="https://gamesheet.app">
                  Log In
                </a>
              </li>
            </ul>
          </div>
          <div className={`sports-links__container ${sportsLinksOpen ? "" : "sports-links__container--hidden"}`}>
            <ul className="sports-links">
              <li className="sports-links__link">
                <h5><a href="https://gamesheetinc.com/hockey">
                  Hockey
                </a></h5>
                <p>Ice / Ball / Sledge</p>
                <p className="sports-links__description">Built for saving hockey associations countless hours every season.</p>
              </li>
              <li className="sports-links__link">
                <h5><a href="https://gamesheetinc.com/lacrosse">
                  Lacrosse
                </a></h5>
                <p>Field / Box</p>
                <p className="sports-links__description">Lacrosse score keeping goes digital.</p>
              </li>
              <li className="sports-links__link">
                <h5><a href="/soccer">
                  Soccer
                </a></h5>
                <p>Outdoor / Indoor / Futsal</p>
                <p className="sports-links__description">A digital scoring solution designed specifically for soccer.</p>
              </li>
            </ul>
          </div>
        </div>
      </StyledNavigation>
    </StyleSheetManager>
  );
};

export default Navigation;
